import { render, staticRenderFns } from "./DrawerSettingsContainer.vue?vue&type=template&id=dd5d3642&scoped=true"
import script from "./DrawerSettingsContainer.vue?vue&type=script&lang=js"
export * from "./DrawerSettingsContainer.vue?vue&type=script&lang=js"
import style0 from "./DrawerSettingsContainer.vue?vue&type=style&index=0&id=dd5d3642&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5d3642",
  null
  
)

export default component.exports